import React from 'react'
import { Col, Row } from 'react-bootstrap'
import './invoiceTotalCard.css'

interface InvoiceTotalCardProps {
	heading: string
	value: number
	colour: string
}

const InvoiceTotalCard = (props: InvoiceTotalCardProps) => {
	const [dollars, cents] = String(props.value).split('.')
	return (
		<div className={`invoice-total-card bg-${props.colour}`}>
			<Row>
				<Col>
					<span className="caption">{props.heading}</span>
				</Col>
			</Row>
			<Row>
				<Col>
					<span className="sign">$</span>
					<span className="dollars">{Number(dollars).toLocaleString()}</span>
					<span className="cents">.{(cents || '').padStart(2, '0')}</span>
				</Col>
			</Row>
		</div>
	)
}

export default InvoiceTotalCard
